import { enqueueSnackbar } from "notistack";
import { AUTO_HIDE_DURATION_DEFAULT, SNACKBAR_SEVERITY } from "@constants/notificationStack";
import type { ShowSnackbarOptions } from "./types/types";

export const showNotification = ({
	message,
	severity = SNACKBAR_SEVERITY.INFO,
	autoHideDuration = AUTO_HIDE_DURATION_DEFAULT,
	title,
	description,
	apiPath,
}: ShowSnackbarOptions) => {
	// Format message to include API path if provided
	const formattedMessage = apiPath ? `API Path: ${apiPath} - ${message}` : message;

	const content =
		title || description ? (
			<div>
				{title && <div style={{ fontWeight: "bold", marginBottom: 4 }}>{title}</div>}
				<div>{description || message}</div>
			</div>
		) : (
			formattedMessage
		);

	enqueueSnackbar(content, { variant: severity, autoHideDuration });
};
